import React, { useEffect, useState, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';

//
import * as jose from 'jose';
import qs from 'qs';
import axios from 'axios';
import Card from '@mui/material/Card';
import Footer from '../../pages/footer';
import AutoLogout from './AutoLogout';
import {
  removeUserSession,
  tokenIsExpired,
  refreshTokenIsExpired,
  renewToken,
  setRefreshUserSession,
  getMenuAccess,
  getToken,
  getRefreshToken,
  fetchLog,
} from '../../utils/common';
import Header from './header';
import Nav from './nav';
import keycloak from 'src/keycloak';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 69;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  backgroundColor: '#f1fafe',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(5),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [totaldata, setTotaldata] = React.useState(0);
  const location = useLocation();
  const navigate = useNavigate();

const IDLE_TIMEOUT = 10 * 60 * 1000; // 10 minutes
const CHECK_INTERVAL = 20 * 1000; // 20 seconds
const FETCH_INTERVAL = 30 * 1000; // 30 seconds
const idleTimer = useRef(null);
const lastActivityTime = useRef(Date.now());

useEffect(() => {
  const resetIdleTimer = () => {
    if (idleTimer.current) {
      clearTimeout(idleTimer.current);
    }
    idleTimer.current = setTimeout(() => {
      keycloak.logout();
      fetchLog(window.REACT_APP_API_PURE + 'user/logout');
      removeUserSession();
      navigate({ pathname: '/login' });
    }, IDLE_TIMEOUT - 30000);
  };

  const checkToken = () => {
    if (!getToken() || !getRefreshToken()) {
      keycloak.logout();
      fetchLog(window.REACT_APP_API_PURE + 'user/logout');
      removeUserSession();
      navigate({ pathname: '/login' });
    } else {
      const tokenParts = getToken().split('.');
      if (tokenParts.length === 3) {
        const payload = JSON.parse(atob(tokenParts[1]));
        const tokenExpiry = payload.exp * 1000;

        if (tokenExpiry < Date.now()) {
          keycloak.logout();
          fetchLog(window.REACT_APP_API_PURE + 'user/logout');
          console.log('Token has expired');
          alert('Token has expired');
          removeUserSession();
          navigate({ pathname: '/login' });
        }
      } else {
        keycloak.logout();
        fetchLog(window.REACT_APP_API_PURE + 'user/logout');
        console.error('Invalid token format');
        alert('Token has expired');
        removeUserSession();
        navigate({ pathname: '/login' });
      }
    }
  };

  const startCheckingActivity = () => {
    let activityDetected = false;

    const handleActivity = () => {
      activityDetected = true;
      lastActivityTime.current = Date.now(); // Update the last activity time
      resetIdleTimer();
    };

    const interval = setInterval(() => {
      if (activityDetected) {
        checkToken();
        activityDetected = false;

        // Check if we should fetch info based on last activity time
        if (Date.now() - lastActivityTime.current <= FETCH_INTERVAL) {
          fetchInfo();
        }
      }
    }, CHECK_INTERVAL);

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);

    return () => {
      clearInterval(interval);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  };

  startCheckingActivity();
}, [location.pathname]);


  const url = window.REACT_APP_API_PURE + 'user/refresh';
  const fetchInfo = () => {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({
        refresh_token: getRefreshToken(),
      }),
    })
      .then((res) => res.json())
      .then((d) => {
        getMenuAccess();
        setRefreshUserSession(d.access_token, d.refresh_token, d.expires_in);
      });
  };

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} totaldata={totaldata} />
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />
      <Main>
        <Card
          style={{
            margin:
              location.pathname == '/dashboard/alert/detail-alert' || location.pathname == '/dashboard/dataset'
                ? 0
                : 20,
            paddingTop:
              location.pathname == '/dashboard/alert/detail-alert' || location.pathname == '/dashboard/dataset'
                ? 20
                : 0,
            padding:
              location.pathname == '/dashboard/alert/detail-alert' || location.pathname == '/dashboard/dataset'
                ? 0
                : 50,
            backgroundColor:
              location.pathname == '/dashboard/alert/detail-alert' || location.pathname == '/dashboard/dataset'
                ? 'transparent'
                : '',
            boxShadow:
              location.pathname == '/dashboard/alert/detail-alert' || location.pathname == '/dashboard/dataset'
                ? 'none'
                : '',
          }}
        >
          <Outlet />
        </Card>
      </Main>
      <Footer />
    </StyledRoot>
  );
}
